import React, { useState, Fragment } from 'react';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import { Controller, useForm } from 'react-hook-form';
import axios from 'axios';
import { Grid, TextField, Button } from '@material-ui/core';
import { useOtpStyle } from './useOtpStyle';
import { EIR_FEATURE_CONST } from '../eir-feature/EirFeatureConstants';
import Loading from '../shared/Loading';
import { useApolloClient } from '@apollo/client';
import ENDPOINT from '../graphql/GraphQLConstants';

const theme = createMuiTheme({
    typography: {
        textTransform: 'none',
        textAlign: 'left',
        letterSpacing: '0px',
        fontFamily: 'gt-walsheim-regular',
        fontSize: '1rem',
        opacity: 1,
    },
    overrides: {
        MuiTextField: {
            root: {
                fontSize: '16px',
                '@media (min-width:770px) and (max-width: 1024px)': {
                    fontSize: '14px',
                },
            },
        },
        MuiFormLabel: {
            asterisk: {
                color: '#f44336;',
            },
        },
        MuiInputLabel: {
            shrink: {
                fontSize: '16px',
                '@media (min-width:279px) and (max-width: 280px)': {
                    fontSize: '15px',
                },
                '@media (min-width:770px) and (max-width: 1024px)': {
                    fontSize: '14px',
                },
            },
            root: {
                color: 'black',
                fontSize: '14px',
                '@media (min-width:767px) and (max-width: 768px)': {
                    fontSize: '13px',
                },
                '@media (min-width:279px) and (max-width: 280px)': {
                    fontSize: '10px',
                },
                '@media (min-width:770px) and (max-width: 1024px)': {
                    fontSize: '12px',
                },
            },
        },
    },
    palette: {
        primary: {
            main: '#892ba0',
        },
    },
});

export default function EirOtp(props) {
    const graphql = useApolloClient();
    const classes = useOtpStyle();
    const [isLoading, setIsLoading] = useState(false);
    const { register, control } = useForm({
        reValidateMode: 'onChange',
    });
    const [phoneNumber, setphoneNumber] = useState(props.validPhoneNumber);
    const [validationOtpCode, setValidationOtpCode] = useState('');
    const [validationStatus, setvalidationStatus] = useState(false);
    const [requestForOTPError, setRequestForOTPError] = useState('');
    const [validateOTPError, setvalidateOTPError] = useState('');
    const [uuid, setuuid] = useState('');
    const [mobileNumberValidation, setmobileNumberValidation] = useState(
        props.MobileValidationStatus ? true : false
    );
    const [phonePatternError, setphonePatternError] = useState(false);
    const [emptyPhoneError, setemptyPhoneError] = useState(false);
    const [otpPatternError, setotpPatternError] = useState(false);
    const [emptyotpError, setotpError] = useState(false);
    const [getCodebtn, setgetCodebtn] = useState(props.validPhoneNumber != '' ? false : true);
    const [validateCodeBtn, setvalidateCodeBtn] = useState(true);
    const [notificationMsg, setNotificationMSg] = useState(
        props.validPhoneNumber != '' ? true : false
    );
    // validate the phone number
    const handleOnPhoneChange = event => {
        setphoneNumber(event.target.value);
        setRequestForOTPError('');
        props.handlephoneNumberEmpty(false);
        props.handlemobileValidationerror(false);
        let phoneValue = event.target.value;
        var regex = /^08[0-9]{8}$/;
        if (phoneValue == '') {
            setemptyPhoneError(true);
            setphonePatternError(false);
            setgetCodebtn(true);
            setNotificationMSg(false);
        } else if (regex.test(phoneValue) == false) {
            setphonePatternError(true);
            setemptyPhoneError(false);
            setgetCodebtn(true);
            setNotificationMSg(false);
        } else {
            setphonePatternError(false);
            setNotificationMSg(true);
            setemptyPhoneError(false);
            props.storeValidePhoneNumber(event.target.value);
            setgetCodebtn(false);
        }
        return event.target.value;
    };
    //validate  OTP has 6 didgits or not
    const handleOnOtpChange = event => {
        setValidationOtpCode(event.target.value);
        setvalidateOTPError('');
        setNotificationMSg(false);

        let otpValue = event.target.value;
        var regex = /^[0-9]{6}$/;
        if (otpValue == '') {
            setotpError(true);
            setotpPatternError(false);
            setvalidateCodeBtn(true);
        } else if (regex.test(otpValue) == false) {
            setotpPatternError(true);
            setotpError(false);
            setvalidateCodeBtn(true);
        } else {
            setotpPatternError(false);
            setotpError(false);
            setvalidateCodeBtn(false);
        }
        return event.target.value;
    };
    //get the OTP for the entered phone number
    const requestForRetryOTP = () => {
        setvalidateOTPError('');
        setvalidationStatus(false);
        setValidationOtpCode('');
        setvalidateCodeBtn(true);
        setotpError(false);
        setotpPatternError(false);
        props.handlephoneNumberEmpty(false);
        setNotificationMSg(false);
        props.handlemobileValidationerror(false);
    };
    const requestForOTP = async () => {
        setIsLoading(true);
        setNotificationMSg(false);
        setRequestForOTPError('');
        try {
            const res = await graphql.query({
                query: ENDPOINT.GET_OTP,
                variables: { msisdn: phoneNumber },
            });
            // const res = await axios.post(EIR_FEATURE_CONST.url.EIR_OTP_URL, {
            //     msisdn: phoneNumber,
            // });

            if (res.data.OTP) {
                setIsLoading(false);
                setvalidationStatus(true);
                setRequestForOTPError('');
                setuuid(res.data.OTP.otpUuid);
                props.handlephoneNumberEmpty(false);
                props.handlemobileValidationerror(false);
            }
        } catch (err) {
            setIsLoading(false);
            setRequestForOTPError(err.message);
            setvalidationStatus(false);
            props.handlephoneNumberEmpty(false);
            props.handlemobileValidationerror(false);
        }
    };
    // verify the OTP and set mobile validation status to true
    const validateOtp = async () => {
        setvalidateOTPError('');
        setIsLoading(true);
        try {
            // const res = await axios.post(
            //     EIR_FEATURE_CONST.url.EIR_OTP_VALIDATION_URL + `${uuid}/validate`,
            //     { otp: validationOtpCode }
            // );
            const res = await graphql.mutate({
                mutation: ENDPOINT.VALIDATE_OTP,
                variables: { otpUuid: uuid, otp: validationOtpCode },
            });

            if (res.data.validateOTP) {
                setIsLoading(false);
                setmobileNumberValidation(true);
                props.handleMobileValidationStatus(true);
                setvalidationStatus(false);
            }
        } catch (err) {
            setIsLoading(false);
            setvalidateOTPError(err.message);
        }
    };
    return (
        <Fragment>
            <ThemeProvider theme={theme}>
                <div className={classes.eirOtp}>
                    {!validationStatus && (
                        <Grid container spacing={2}>
                            <Grid
                                item
                                xs={12}
                                sm={mobileNumberValidation ? 6 : 4}
                                md={mobileNumberValidation ? 6 : 4}>
                                <div className={mobileNumberValidation ? 'tickright' : ''}>
                                    <Controller
                                        as={
                                            <TextField
                                                InputProps={{
                                                    readOnly: mobileNumberValidation,
                                                }}
                                            />
                                        }
                                        required
                                        control={control}
                                        fullWidth
                                        id='PhoneNumber'
                                        name='PhoneNumber'
                                        label='Phone number'
                                        variant='outlined'
                                        size='small'
                                        placeholder='08XXXXXXXX'
                                        onChange={([event]) => {
                                            return handleOnPhoneChange(event);
                                        }}
                                        inputRef={register}
                                        defaultValue={phoneNumber}
                                        rules={{ required: true, pattern: /^[0-9]{10}$/ }}
                                    />
                                </div>
                                {(emptyPhoneError || props.phoneNumberEmpty) && (
                                    <span className='errorMessage'>
                                        Please enter your phone number
                                    </span>
                                )}
                                {phonePatternError && (
                                    <span className='errorMessage'>
                                        Must start with 08 and be 10 digits long
                                    </span>
                                )}
                                <span className='errorMessage'>{requestForOTPError}</span>
                                {mobileNumberValidation && (
                                    <span className='notification'>Mobile number verified</span>
                                )}
                                {notificationMsg && !mobileNumberValidation && (
                                    <span className='notification'>
                                        Verify this number by getting a code to move to the next
                                        step.
                                    </span>
                                )}
                            </Grid>
                            {!mobileNumberValidation && (
                                <Grid item xs={12} sm={7}>
                                    <Button
                                        variant='contained'
                                        disabled={getCodebtn}
                                        className={getCodebtn ? 'OtpButton' : 'OtpPurpleButton'}
                                        onClick={requestForOTP}>
                                        Get code
                                    </Button>
                                </Grid>
                            )}
                        </Grid>
                    )}

                    {validationStatus && (
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={3} md={3}>
                                <Controller
                                    as={<TextField disabled={mobileNumberValidation} />}
                                    required
                                    control={control}
                                    fullWidth
                                    id='ValidationCode'
                                    name='ValidationCode'
                                    label='Verification code'
                                    variant='outlined'
                                    size='small'
                                    defaultValue={validationOtpCode}
                                    inputRef={register}
                                    placeholder='Verification code'
                                    onChange={([event]) => {
                                        return handleOnOtpChange(event);
                                    }}
                                    rules={{ required: true, pattern: /^[0-9]{6}$/ }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={7}>
                                <Button
                                    variant='contained'
                                    className='retryBtn'
                                    onClick={requestForRetryOTP}>
                                    Retry
                                </Button>
                                <Button
                                    variant='contained'
                                    disabled={validateCodeBtn}
                                    className={
                                        validateCodeBtn ? 'OtpValidButton' : 'OtpValidPurpleButton'
                                    }
                                    onClick={validateOtp}>
                                    Confirm
                                </Button>
                            </Grid>
                            {(emptyotpError || otpPatternError || validateOTPError != '') && (
                                <Grid item xs={12} sm={12}>
                                    <Grid item xs={12} sm={6} md={4}>
                                        {emptyotpError && (
                                            <span className='errorMessage'>
                                                Please enter verification code
                                            </span>
                                        )}
                                        {otpPatternError && (
                                            <span className='errorMessage'>
                                                Must be 6 characters long
                                            </span>
                                        )}
                                        {validateOTPError && (
                                            <span className='errorMessage'>{validateOTPError}</span>
                                        )}
                                    </Grid>
                                </Grid>
                            )}
                            <Grid item xs={12} sm={6} md={5} className='paddingClass'>
                                <span className='notification'>
                                    Please check your phone for verification code. Please verify
                                    this code to move to the next step. This code will expire in 1
                                    minute.
                                </span>
                            </Grid>
                        </Grid>
                    )}
                </div>
                {isLoading && <Loading />}
            </ThemeProvider>
        </Fragment>
    );
}
